<template>
     <div class="edu">
        <!-- <div class="heading2-section">
            Education
        </div> -->
     <form>
   
        <div class="mb-3">
    <label class="form-label">School</label>
    <input type="text" v-model="ed.school" placeholder="Secondary School Or College/University" class="form-control">
    </div>
       <div class="mb-3">
    <label class="form-label">Certificate</label>
    <input type="text" v-model="ed.certificate" placeholder="Awarded Certificate" class="form-control">
    </div>
   <div class="mb-3">
        <label class="form-label">Location</label>
        <input type="text"  v-model="ed.location" placeholder="City, Country" class="form-control">
    </div>
    
    <div class="mb-3">
        <label class="form-label">Study Period</label>
       <div class="select-dates">
        <div class="select-date">
            <!-- start month -->
            <select class="form-select"  v-model="dates.startMonth" id="monthSelect">
                <!-- <option selected disabled>Select Month</option> -->
                <option>January</option>
                <option>February</option>
                <option>March</option>
                <option>April</option>
                <option>May</option>
                <option>June</option>
                <option>July</option>
                <option>August</option>
                <option>September</option>
                <option>October</option>
                <option>November</option>
                <option>December</option>
            </select>
            <!-- start year -->
              <select class="form-select" v-model="dates.startYear" id="yearSelect">
                <!-- <option selected disabled>Select Year</option> -->
                <option v-for="year in years" :key="year">{{ year }}</option>
            </select>
        </div>
        <!-- to -->
         <div class="to">To</div>

         <div class="select-date">
            <!-- start month -->
            <select class="form-select" @change="updateEndDate" v-model="dates.endMonth" id="monthSelect">
                <!-- <option selected disabled>Select Month</option> -->
                <option>January</option>
                <option>February</option>
                <option>March</option>
                <option>April</option>
                <option>May</option>
                <option>June</option>
                <option>July</option>
                <option>August</option>
                <option>September</option>
                <option>October</option>
                <option>November</option>
                <option>December</option>
            </select>
            <!-- start year -->
              <select class="form-select" @change="updateEndDate"  v-model="dates.endYear" id="yearSelect">
                <!-- <option selected disabled>Select Year</option> -->
                <option v-for="year in years" :key="year">{{ year }}</option>
            </select>
        </div>
         

       </div>
    </div>
    <div class="mb-3">
                <div class="form-check">
        <input class="form-check-input" 
        v-model="currentlyStudying"
        @change="changeEndDate"
        type="checkbox" value="" id="checkDefault">
        <label class="form-check-label" for="checkDefault">
        Currently studying here
        </label>
                </div>
    </div>

    <div class="form-floating mt-6">
            <div ref="editor" class="custom-quill"></div>
        </div>
        
        <div class="form-buttons mb-3">
            <div class="button-subgroup" v-if="isAdding">
                <button type="submit" class="btn btn-default primary-btn" v-if="loading && buttonClicked" disabled>Adding Education...</button>
                <button type="submit" class="btn btn-default primary-btn" @click.prevent="addEducation()" v-else>Add Education</button>
            </div>
            <div class="button-subgroup" v-else>
                <button type="submit" class="btn btn-default primary-btn" v-if="loading && buttonClicked" disabled>Updating Education...</button>
                <button type="submit" class="btn btn-default primary-btn" @click.prevent="editEducation()" v-else>Update Education</button>
                <button type="submit" class="btn btn-default primary-btn badge-cancel"v-if="!loading && !buttonClicked" @click.prevent="cancel()">Cancel Edit</button>
            </div>
        </div>
        <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors --> 
    </form>
    <LoadingIndicator v-if="loading"/>
    <!-- START history -->
    <div class="history">
        <!-- histories -->
        <div class="hist" v-for="education in educations" :key="education.educationId">
            <div class="hist-details">
                <div class="hist-title">{{ education.school }}</div>
                <div class="hist-company">{{ education.certificate }}</div>
                <div class="hist-date">{{ education.startDate }} - {{ education.endDate }}</div>
            </div>
            <div class="hist-controls">
                <button class="btn btn-default button-primary hist-button" @click.prevent="reviewEducation(education)" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">Edit</button>
                <button class="btn btn-danger hist-button" :id="education.educationId" @click.prevent="deleteEducation(education.educationId)" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">Delete</button>
            </div>
        </div>
        <!--  -->
    </div>
    <!-- END OF HISTORY -->
    </div>
    <CustomConfirmationMessageModal :title="modal.caption"
            ref="edConfirmModal"
           :body="modal.message"
           :button-label="modalButtonLabel"
           :close-modal="() => closeModal()"
           :modal-id="modalId"/>
    <WarningOptionsModal
            ref="edDelModal"
            :body="this.delModal.body"
            :title="this.delModal.title"
            :close-modal="this.delModal.closeModal"
            :yes-selected="this.delModal.yesSelected"
            :yes-button-label="this.delModal.yesButtonLabel"
            :no-button-label="this.delModal.noButtonLabel"
            :modal-id="this.delModal.modalId"
            loading-button-label="Deleting Education..."
            />
    
</template>
<script>
    import Quill from 'quill'
    import 'quill/dist/quill.snow.css'
    import { addEducationAsync, editEducationAsync, deleteEducationAsync } from '@/services/cvbuilderService';
    import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
    import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
    import WarningOptionsModal from '@/components/modals/WarningOptionsModal.vue';
export default {
     components:{
        LoadingIndicator,
        CustomConfirmationMessageModal,
        WarningOptionsModal
    },
      data() {
    return {
        isAdding: true,
     ed:{
                school:"",
                certificate:"",
                location:"",
                startDate:"",
                endDate:"",
                description:""
            },
        dates:{
            startMonth:"",
            startYear:"",
            endMonth:"",
            endYear:""
        },
        currentlyStudying:false,
        modal:{
                caption:"",
                message:""
            },
        delModal:{
            title:"",
            body:"",
            modalId:"delEd",
            yesButtonLabel:"Delete History",
            noButtonLabel:"Cancel",
            closeModal: null,
            yesSelected: null
        },
         selectedEdId:"",
            errors:[],
            loading:false,
            buttonClicked:false,
            hasErrors:false,
            modalButtonLabel:'Close',
            modalId:"addEd",
      years: []
    };
  },
  mounted(){
    this.setupQuill();
  },
  created() {
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= 1980; y--) {
      this.years.push(y);
    }
  },
  computed:{
          educations(){
            var eds = this.$store.getters["cvbuilder/getCVInformation"]?.educations || [];
            return eds;
        }
    },
    methods:{
            
            setupQuill(){
                // Initialize Quill
            this.quill = new Quill(this.$refs.editor, {
            theme: 'snow',
            modules: {
                toolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link']
                ]
            }
            });
            //set present values
            this.quill.root.innerHTML = this.ed.description;

            // Listen for changes and update Vue data
            this.quill.on('text-change', () => {
             this.ed.description = this.quill.root.innerHTML
            })
        },
         updateEndDate(){
            this.currentlyStudying = false;//when an an actual end value has been selected
        },
        changeEndDate(){
            if(this.currentlyStudying){
                this.dates.endMonth = this.dates.endYear = null;
            }
        },
        updateDeleteButton(id, isDisabled, label){
            let btn = document.getElementById(id);
            btn.disabled = isDisabled;
            btn.innerHTML = label;
            
        },
        resetOnNewDelete(){
                this.loading = true;
                this.hasErrors = false;
                this.errors = [];
        },
        stopOnDeleteError(message){
            this.errors.push(message);
            this.hasErrors = true; 
            this.loading = false;
            this.clearErrors();
        },
        shortMonth(month){
            const date = new Date(`${month} 1, 2000`); // dummy day/year
            return date.toLocaleString('en-US', { month: 'short' });
        },
        setIdForDelete(educationId){
            this.delModal.title = "Delete Academic History",
            this.delModal.body = "Are you sure you want to delete this academic history?"
            this.delModal.yesSelected = async() => await this.deleteEducation(educationId);
            this.delModal.closeModal = () => this.closeDelModal();
            this.showDelModal();
        },
        async deleteIdFromModalButton(){
            await this.deleteEducation(this.idForDelete);
        },
        async deleteEducation(educationId){
            try{     
                this.resetOnNewDelete();
                this.updateDeleteButton(educationId,true,"Deleting...");
                this.resetOnBadgeSelection();
                var data = await deleteEducationAsync(educationId);
                if(!data.success){
                    throw new Error(data.message, {cause: data.caption})
                }else{
                    this.closeDelModal();
                    this.$store.dispatch("cvbuilder/removeEducation",educationId);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.ed = {
                                   school:"",
                                    certificate:"",
                                    location:"",
                                    startDate:"",
                                    endDate:"",
                                    description:""
                                };
                    this.dates = {
                                startMonth:"",
                                startYear:"",
                                endMonth:"",
                                endYear:""
                            };
                }
            }catch(e){
               this.stopOnDeleteError(e.message);             
                this.updateDeleteButton(educationId,false,"Delete");
            }
        },
        async editEducation(){
            try{  
                var result = this.resolveAndValidateDates();
                if (!result) {
                    return; // stop execution, errors are already set
                 }
                 var {startDate, endDate} = result;

                 var body = {
                    school: this.ed.school, 
                    certificate: this.ed.certificate,
                    location: this.ed.location,
                    startDate,
                    endDate, 
                    description: this.ed.description,
                    educationId: this.selectedEdId
                }
                this.resetOnNewSubmit();   
                var data = await editEducationAsync(body);
                if(!data.success){
                    if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                        });
                        this.hasErrors = true;
                        this.buttonClicked = false;
                        this.loading = false;
                        this.clearErrors();
                        return;
                    }
                throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/updateEducation", body);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.ed = {
                                   school:"",
                                    certificate:"",
                                    location:"",
                                    startDate:"",
                                    endDate:"",
                                    description:""
                                };
                    this.dates = {
                                startMonth:"",
                                startYear:"",
                                endMonth:"",
                                endYear:""
                            };
                     this.quill.root.innerHTML = "";
                     this.currentlyStudying = false;
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        async addEducation(){
            try{   
                var result = this.resolveAndValidateDates();
                if (!result) {
                    return; // stop execution, errors are already set
                 }
                 var {startDate, endDate} = result;
                var body = {
                    school: this.ed.school, 
                    certificate: this.ed.certificate,
                    location: this.ed.location,
                    startDate: startDate,
                    endDate: endDate,
                    description: this.ed.description
                }
                this.resetOnNewSubmit();   
                var data = await addEducationAsync(body);
                if(!data.success){
                    if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                        });
                        this.hasErrors = true;
                        this.buttonClicked = false;
                        this.loading = false;
                        this.clearErrors();
                        return;
                    }
                throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/addNewEducation", data.education);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                     this.ed = {
                                   school:"",
                                    certificate:"",
                                    location:"",
                                    startDate:"",
                                    endDate:"",
                                    description:""
                                };
                    this.dates = {
                                startMonth:"",
                                startYear:"",
                                endMonth:"",
                                endYear:""
                            };
                     this.quill.root.innerHTML = "";
                     this.currentlyStudying = false;
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        clearFieldsBeforeReview(){

                    this.ed = {
                        school:"",
                        certificate:"",
                        location:"",
                        startDate:"",
                        endDate:"",
                        description:""
                    };
                    this.dates = {
                                startMonth:"",
                                startYear:"",
                                endMonth:"",
                                endYear:""
                            };
                    this.quill.root.innerHTML = "";
                    this.currentlyStudying = false;
        },
         reviewEducation(education){
             this.clearFieldsBeforeReview();

            this.isAdding = false;
            this.ed = {
                school: education.school,
                certificate: education.certificate,
                location: education.location,
                startDate: "",
                endDate:"",
                description: education.description
            };
            this.sortDatesForEditing(education);
            this.quill.root.innerHTML = education.description;
            this.selectedEdId = education.educationId
        },
        sortDatesForEditing(education){
            if(education.endDate == 'Present'){
                this.currentlyStudying = true;
            }else{
                let endMonth;
                let endYear;
                let endArray = education.endDate.split(" ");
                endMonth = endArray[0]; //short month
                endYear = endArray[1]// year
                let fullEndMonth = this.parseFullMonth(endMonth);
                this.dates.endMonth = fullEndMonth;
                this.dates.endYear = endYear;
            }

                let startMonth;
                let startYear;
                let startArray = education.startDate.split(" ");
                startMonth = startArray[0]; //short month
                startYear = startArray[1]// year
                let fullStartMonth = this.parseFullMonth(startMonth);
                this.dates.startMonth = fullStartMonth;
                this.dates.startYear = startYear;
        },
        parseFullMonth(shortMonth){ //default 'January'
            try{
                if(shortMonth.trim().length == 3){
                    const date = new Date(`${shortMonth} 1, 2000`);
                    if(isNaN(date)){ //if invalid date, throw
                        let err = new Error();
                        throw err;
                    }
                    return date.toLocaleString('en-US', { month: 'long' });
                }else{
                    return 'January';
                }
            }catch(e){
                return 'January';
            }
        },
           toggleEndDate(){
            if(!this.currentlyStudying)
            {
            // Checkbox was unchecked - now mark as currently working
                    this.currentlyStudying = true;
                    this.work.endMonth = "Present";
                    this.work.endYear = "";
                }else{
            // Checkbox was checked - now mark as not currently working
                    this.currentlyStudying = false;
                    this.work.endMonth = "";
                    this.work.endYear = "";
            }
        },
         cancel(){
            this.isAdding = true;
            this.ed = {
               school:"",
                certificate:"",
                location:"",
                startDate:"",
                endDate:"",
                description:""
            };
            this.dates = {
                startMonth:"",
                startYear:"",
                endMonth:"",
                endYear:"",
            }
            this.quill.root.innerHTML = "";
            this.currentlyStudying = false;
        },
        closeModal(){
        if (this.$refs.edConfirmModal && typeof this.$refs.edConfirmModal.hide === 'function') {
        this.$refs.edConfirmModal.hide();
        }
        },
        showModal(){
            this.$refs.edConfirmModal.show();
        },
         closeDelModal(){
        if (this.$refs.edDelModal && typeof this.$refs.edDelModal.hide === 'function') {
        this.$refs.edDelModal.hide();
        }
        },
        showDelModal(){
            this.$refs.edDelModal.show();
        },
         resetOnNewSubmit(){
                this.loading = true;
                this.buttonClicked = true;
                this.hasErrors = false;
                this.errors = [];
        },
         resetOnBadgeSelection(){
                this.loading = true;
                //this.buttonClicked = true; //cause no form button is clicked
                this.hasErrors = false;
                this.errors = [];
        },
        resolveAndValidateDates(){
                    var startDate =
                this.dates.startMonth && this.dates.startYear
                    ? `${this.shortMonth(this.dates.startMonth)} ${this.dates.startYear}`
                    : '';

                var endDate = this.currentlyStudying
                ? 'Present'
                : (this.dates.endMonth && this.dates.endYear
                    ? `${this.shortMonth(this.dates.endMonth)} ${this.dates.endYear}`
                    : '');

                // Simple validation
                if (!startDate) {
                    this.errors = ['Please select a valid start month and year.'];
                    this.hasErrors = true;
                    this.clearErrors();
                    return;
                }
                if (!this.currentlyStudying && !endDate) {
                    this.errors = ['Please select a valid end month and year or mark that you currently study here.'];
                    this.hasErrors = true;
                    this.clearErrors();
                    return;
                }

                return {startDate, endDate}
        },
        clearErrors(){
            setTimeout(() => {
                this.errors = [];
                this.hasErrors = false;
            }, 3000);          
        }
    }
}
</script>
<style scoped>
    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

  .custom-quill.ql-container.ql-snow{
        background-color: var(--editor-background2)!important;
        color:var(--foreground);
    }

@media (max-width:768px) {
    .select-dates{
        flex-direction: column;
        align-items: flex-start;
        row-gap: 0.7rem;
    }
}
</style>